import { TABLES_KEYS } from 'features/ai-generators/constants';
import strings from 'strings';

export const COPIES = strings.shared.savedSearches;
export const PAGE_KEY = TABLES_KEYS.savedSearches;
export const SAVED_SEARCH_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'name',
    label: 'Search Name',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'description',
    label: 'Description',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'search',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'updatedAt',
    label: 'Last Update',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'createdAt',
    label: 'Created At',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'createdBy.id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'createdBy.name',
    label: 'Owner',
    options: {
      sort: false,
      display: true
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'updatedAt',
  direction: 'desc'
};

export const SCOPE_OPTIONS = [
  { id: 0, title: COPIES.shareDrawer.scopeOptions.mine },
  { id: 1, title: COPIES.shareDrawer.scopeOptions.sharedWithMe },
  { id: 3, title: COPIES.shareDrawer.scopeOptions.sharedToOthers },
  { id: 2, title: COPIES.shareDrawer.scopeOptions.all }
];

export const COLUMNS_TO_EXTRACT = ['id', 'createdBy.id', 'createdBy.name', 'name', 'search'];
